import { useEffect } from "react";

/**
 * Presence Mode — after 25s of no interaction on a reading page, softly dims
 * the chrome via `data-presence` on <html>. Any interaction removes it. Does
 * not force Focus Mode; complements it.
 */
export function PresenceMode() {
  useEffect(() => {
    if (typeof window === "undefined") return;
    if (window.matchMedia?.("(prefers-reduced-motion: reduce)").matches) return;

    let timer: ReturnType<typeof setTimeout> | null = null;
    const doc = document.documentElement;

    const enter = () => doc.setAttribute("data-presence", "on");
    const exit = () => doc.removeAttribute("data-presence");

    const schedule = () => {
      if (timer) clearTimeout(timer);
      exit();
      timer = setTimeout(enter, 25_000);
    };

    const events: Array<keyof WindowEventMap> = ["pointermove", "scroll", "keydown", "touchstart", "wheel"];
    events.forEach((e) => window.addEventListener(e, schedule, { passive: true }));
    schedule();

    return () => {
      events.forEach((e) => window.removeEventListener(e, schedule));
      if (timer) clearTimeout(timer);
      exit();
    };
  }, []);
  return null;
}
